import { createPostRequest } from "../helpers/common-apis";
import {saveToStorage} from "./LocalStorage";
import {KEY_ADMIN_AUTH_TOKEN} from "../helpers/Constants";

const PARTNER_API_BASE_URL =  process.env.REACT_APP_PARTNER_API_BASE_URL;

export const searchPartners = async (request) => {
  const postRequest = await createPostRequest(
      `${PARTNER_API_BASE_URL}/admin-user-mgt/gc/find-partner-and-status`,
      request
  );
  const response = await fetch(postRequest);

  if (!response.ok) {
    const errorText = await response.text();
    throw new Error(`HTTP error! status: ${response.status}, message: ${errorText}`);
  }

  return await response.json();
};

export const findPartnersByEmail = async (userEmail, partnerEmail = "", filterParam = "") => {
  return searchPartners({
    adUserEmail: userEmail,
    domainName: "Grubtech",
    partnerEmail: partnerEmail,
    partnerIdNameFilterParam: filterParam,
  });
};

export const requestAccess = async (payload) => {
  const postRequest = await createPostRequest(
      `${PARTNER_API_BASE_URL}/admin-user-mgt/gc/request-access`,
      payload
  );

  const response = await fetch(postRequest);

  if (!response.ok) {
    throw new Error("Failed to request access");
  }

  return response.json();
};

export const authenticateAdminUser = async (payload) => {
  const postRequest = await createPostRequest(
      `${PARTNER_API_BASE_URL}/admin-user-auth/user-authentication/authenticate`,
      payload
  );

  const response = await fetch(postRequest);

  if (!response.ok) {
    throw new Error("Failed to authenticate");
  }

  const data = await response.json();

  if (data && data.idToken) {
    saveToStorage(KEY_ADMIN_AUTH_TOKEN, data.idToken);
  }

  return data;
};
